import { Card } from 'components/ui/card';

export function CardRoot({ children }: { children: React.ReactNode }) {
  return <Card>{children}</Card>;
}
